import { checkContactExists } from '@src/reducers/contactVCard';
import { contactExistsStatusSelector } from '@src/selectors/contact';
import { RootState } from '@src/store/reduxstore';
import { ResponseStatus } from '@src/types/chats';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useContactUtils from './useContactUtils';

const finalStatusContact = [ResponseStatus.SUCCESS, ResponseStatus.FAILURE];

const useContactExists = (mobilePhone: string) => {
  const dispatch = useDispatch();
  const { formatContactPhone } = useContactUtils();

  const [isContactExists, setIsContactExists] = useState(false);
  const [isCompletedContactRequest, setIsCompletedContactRequest] =
    useState(false);

  const mobilePhoneNumber = useMemo(
    () => formatContactPhone(mobilePhone),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mobilePhone]
  );

  const contactExistsStatus = useSelector((state: RootState) =>
    contactExistsStatusSelector(mobilePhoneNumber)(state)
  );

  useEffect(() => {
    if (mobilePhone && !finalStatusContact.includes(contactExistsStatus)) {
      setIsCompletedContactRequest(false);
      dispatch(checkContactExists({ mobilePhoneNumber }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobilePhone]);

  useEffect(() => {
    const isFinalStatus = finalStatusContact.includes(contactExistsStatus);

    if (mobilePhone && isFinalStatus) {
      setIsCompletedContactRequest(true);
      setIsContactExists(contactExistsStatus === ResponseStatus.SUCCESS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactExistsStatus]);

  return { isContactExists, isCompletedContactRequest };
};

export default useContactExists;
